import moment from 'moment'
import { getDateArray } from './getChannelsChartData'

import { ChannelEvent } from 'types'

type EventsMapped = {
  [key: string]: ChannelEvent[]
}

type MapType = 'day' | 'week' | 'month'
export const mapByTime = (
  data: ChannelEvent[] = [],
  type: MapType,
  timezone: string
) => {
  const formatType =
    type === 'day' ? 'D/MM/YY' : type === 'week' ? 'W/YY' : 'MMM/YY'

  const eventByDay: EventsMapped = {}

  const dates = getDateArray(type, timezone)

  // Initialize the object with empty arrays
  for (const date of dates) {
    eventByDay[date] = []
  }

  for (const evt of data) {
    if (!evt.stats_event_date) continue
    
    // Parse the ISO date string from BigQuery and format it correctly
    let day
    try {
      // Handle ISO date format from BigQuery (e.g., "2025-07-31")
      day = moment(evt.stats_event_date).format(formatType)
      console.log('Original date:', evt.stats_event_date, 'Formatted date:', day, 'Available dates:', Object.keys(eventByDay))
    } catch (error) {
      console.warn('Failed to parse date:', evt.stats_event_date, error)
      continue
    }
    
    if (eventByDay[day]) {
      eventByDay[day].push(evt)
    } else {
      console.warn('Date not found in expected dates:', day)
    }
  }

  return eventByDay
}
